import {createStrokeSVG} from './TEMPLATE'

// tabler: mail-opened
export const Envelope_Open_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 9l9 6l9 -6l-9 -6l-9 6',
    'M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10',
    'M3 19l6 -6',
    'M15 13l6 6',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
